import { render, staticRenderFns } from "./PatientsCountriesModal.vue?vue&type=template&id=8f234b1a&"
import script from "./PatientsCountriesModal.vue?vue&type=script&lang=js&"
export * from "./PatientsCountriesModal.vue?vue&type=script&lang=js&"
import style0 from "../../../node_modules/handsontable/dist/handsontable.full.css?vue&type=style&index=0&lang=css&"
import style1 from "./PatientsCountriesModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports